import type { RangeKey } from '@dataTypes/dashboard.types'

export const OVERVIEW_DASHBOARD_LOADING_CONTAINER = '.dashboard-overview'

export const OVERVIEW_DETAIL_LOADING_CONTAINER =
  '.overview-detail-loading-container'

export const PROCEDURES_DETAIL_LOADING_CONTAINER =
  '.procedures-detail-container'

export const COLLECTION_DETAIL_LOADING_CONTAINER =
  '.collection-detail-container'

export const OVERVIEW_PROGRESS_CHART_TITLES: Record<RangeKey, string> = {
  '1D': "Today's progress",
  '1W': "This week's progress",
  '1M': "This month's progress",
  '1Y': "This year's progress",
  YTD: 'YTD progress',
}
